import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastyService } from 'ng2-toasty';
import { ControlRegisterSections } from '../../../abstration/control-register-sections';
import { AgentDocument } from '../../../models/agents/agent-document';
import { MixpanelService } from '../../../services/mix-panel.service';
import { PH3AService } from '../../../services/PH3A.service';
import { LoadingService } from '../../../services/loading.service';
import swal from 'sweetalert2';
import { MultipleEmail } from '../../../models/agents/multiple-email';
import { MultipleEmailComponent } from '../multiple-email/multiple-email.component';
import { FormatHelper } from '../../../helpers/format-helper';
import { CompanyService } from '../../../services/company.service';

@Component({
  selector: 'app-people-form',
  templateUrl: './people-form.component.html',
  styleUrls: ['./people-form.component.scss'],
  animations: [
    trigger('simpleFadeAnimation', [
      state('in', style({ opacity: 1 })),
      transition(':enter', [style({ opacity: 0 }), animate(600)]),
      transition(':leave', animate(600, style({ opacity: 0 })))
    ])
  ]
})
export class PeopleFormComponent extends ControlRegisterSections implements OnInit, OnChanges {
  @Input() formGroup: FormGroup;
  @Input() peopleType: string;
  @Input() defaultValue: any;
  @Input() allowEditing = true;
  @Input() newRegister = true;
  @Input() formName: string;
  @Input() emailIndex: number;
  @Input() documentType: string;
  @Input() maskInput: string;
  @Output() onAdd = new EventEmitter<any>();
  @Output() onDelete = new EventEmitter<any>();
  @Output() onClose = new EventEmitter();
  @Output() onDisableButton = new EventEmitter<boolean>();
  @Output() onEmailUpdate = new EventEmitter<any>();
  @ViewChild('multipleEmail') multipleEmail: MultipleEmailComponent;

  isVisibleForm = false;
  saveButtonDisabled = false;
  title: string;
  headerContent: string;
  peopleTitle: string;
  maxLengthField: string;

  dictionary = {
    Director: 'diretor',
    Partner: 'sócio',
    RelationshipContact: 'contato de relacionamento',
    IRD: 'diretor de relação com investidores'
  };

  maxLengthDictionary = {
    Director: '14',
    Partner: '18'
  };

  constructor(
    protected toastyService: ToastyService,
    protected formBuilder: FormBuilder,
    protected mixpanel: MixpanelService,
    protected phService: PH3AService,
    protected loadingService: LoadingService,
    protected formatHelper: FormatHelper,
    protected companyService: CompanyService,
  ) {
    super(formBuilder, toastyService, companyService);
  }

  ngOnInit() {
  }

  ngOnChanges() {
    this.getTitle();
    this.setMaxLength();
    this.setCardTitle();
    this.setCardHeaderContent();
    setTimeout(() => {
      if (this.peopleType === 'RelationshipContact') {
        this.setEmails(this.emailIndex);
      }
    }, 100);
  }

  initReactiveForms(callFromNgInit: boolean = false): void {
    if (!callFromNgInit) {
      return;
    }
  }

  setEmails(i: number) {
    const formArray = this.formGroup.get(this.formName) as FormArray;
    const formGroup = formArray.controls[i] as FormGroup;
    let emails: MultipleEmail[];
    if (!formGroup || !formGroup.get('email') || !formGroup.get('email').value) {
      return;
    }
    emails = formGroup
      .get('email')
      .value
      .split(',')
      .map((email) => ({ display: email, value: email }));

    if (this.multipleEmail) { this.multipleEmail.loadingEmail(emails); }
  }

  get formData() {
    return <FormArray>this.formGroup.get(this.formName);
  }

  getTitle() {
    for (const [key, value] of Object.entries(this.dictionary)) {
      if (this.peopleType === key) {
        this.peopleTitle = value;
      }
    }
  }

  setMaxLength() {
    for (const [key, value] of Object.entries(this.maxLengthDictionary)) {
      if (this.peopleType === key) {
        this.maxLengthField = value;
      }
    }
  }

  makeRequired(formControl: FormControl) {
    if (!formControl) {
      return;
    }
    formControl.setValidators([Validators.required, Validators.nullValidator, Validators.minLength(1)]);
    formControl.updateValueAndValidity();
    formControl.markAsTouched({ onlySelf: true });
    formControl.setErrors(null);
  }


  makeOptional(formControl: FormControl) {
    if (!formControl) {
      return;
    }
    formControl.clearAsyncValidators();
    formControl.setValidators([]);
    formControl.updateValueAndValidity();
    formControl.markAsTouched({ onlySelf: true });
    formControl.setErrors(null);
  }

  setCardTitle() {
    if (this.defaultValue && this.defaultValue.document) {
      const { name } = this.defaultValue;
      this.title = name;
    } else {
      this.title = `Novo ${this.peopleTitle}`;
    }
  }

  setCardHeaderContent() {
    if (this.defaultValue && this.defaultValue.document) {
      const document = new AgentDocument(this.defaultValue.document);
      this.headerContent = document.getFormated();
    } else {
      this.headerContent = `Informe os dados abaixo para cadastrar um novo ${this.peopleTitle}`;
    }
  }

  setSaveButtonDisabled(isDisable: boolean) {
    this.saveButtonDisabled = isDisable;
  }

  isValidPeople(index: number) {
    const formArray = this.formGroup.get(this.formName) as FormArray;
    const formGroup = formArray.controls[index] as FormGroup;
    const newRegister = formGroup.get('newRegister') ? formGroup.get('newRegister').value : false;
    if (newRegister || (!formGroup.get('name').value && !formGroup.get('document').value)) {
      formArray.removeAt(index);
    }
  }

  searchPeople(index: number) {
    this.setSaveButtonDisabled(false);
    const formArray = this.formGroup.get(this.formName) as FormArray;
    const formGroup = formArray.controls[index] as FormGroup;
    const document = formGroup.get('document').value.replace(/\D/g, '');
    const agent = new AgentDocument(document);

    if (!document || !agent.isValid()) {
      return;
    }

    this.loadingService.isLoading(true);

    const _handlePerson = (person) => {
      if (person) {
        const name = person.person.fullName;
        formGroup.get('name').setValue(name);
      }
      this.loadingService.isLoading(false);
    };

    const _handleCompany = (company) => {
      if (company) {
        const name = company.company.legalName;
        formGroup.get('name').setValue(name);
      }
      this.loadingService.isLoading(false);
    };

    const _handleError = () => {
      swal({
        title: 'Ops!',
        text: 'Não foi possível realizar a consulta do documento informado',
        type: 'error'
      }).catch(swal.noop);
      this.loadingService.isLoading(false);
    };

    if (agent.isPerson()) {
      this.phService
        .getPersonData(document)
        .subscribe(
          _handlePerson,
          _handleError
        );
    }

    if (agent.isCompany()) {
      this.phService
        .getCompanyData(document)
        .subscribe(
          _handleCompany,
          _handleError
        );
    }
  }

  formatDocument(index: number) {
    const formArray = this.formGroup.get(this.formName) as FormArray;
    const formGroup = formArray.controls[index] as FormGroup;
    const document = formGroup.get('document').value.replace(/\D/g, '');
    const agent = new AgentDocument(document);

    if (!document) {
      return;
    }

    if (agent.isCompany()) {
      const formated = this.formatHelper.StringToCNPJ(document);
      formGroup.get('document').setValue(formated);
    }

    if (agent.isPerson()) {
      const formated = this.formatHelper.StringToCPF(document);
      formGroup.get('document').setValue(formated);
    }
  }

  onClosePeople(index: number) {
    const formArray = this.formGroup.get(this.formName) as FormArray;
    const formGroup = formArray.controls[index] as FormGroup;
    formGroup.get('showAccordeon').setValue(false);
    if (this.peopleType !== 'RelationshipContact') {
      this.isValidPeople(index);
    }
    this.onClose.emit();
  }

  onDeletePeople(index: number) {
    this.onDelete.emit(index);
  }

  validatePartner(index: number) {
    const formArray = this.formGroup.get(this.formName) as FormArray;
    const formGroup = formArray.controls[index] as FormGroup;
    const slice = parseFloat(formGroup.get('slice').value);

    if (slice > 100 || slice === 0) {
      this.warningToast(
        'Informação societárias',
        'Você não pode informar a % societária maior do que 100% ou igual a 0%'
      );
      return formGroup.get('slice').setValue(0);
    }

    if (slice > 15 && slice <= 100) {
      this.makeRequired(<FormControl>formGroup.get('name'));

      if (!formGroup.get('name').value) {
        this.warningToast(
          'Informação societárias',
          'Quando a % societária for maior do que 15% é necessário informar o Nome e CPF'
        );
        return;
      }
      return this.onAdd.emit(index);
    }
    this.makeOptional(<FormControl>formGroup.get('name'));
    this.onAdd.emit(index);
  }

  warningToast(title: string, description: string) {
    this.toastyService.warning({
      title: title,
      msg: description,
      theme: 'bootstrap',
      timeout: 5000,
      showClose: true
    });
  }

  updateEmail(event: string, index: number) {
    const formArray = this.formGroup.get(this.formName) as FormArray;
    const formGroup = formArray.controls[index] as FormGroup;

    formGroup.get('email').setValue(event);
    this.onEmailUpdate.emit({ email: event, index });
  }

  addPeople(index: number) {
    if (this.peopleType === 'Partner') {
      return this.validatePartner(index);
    }

    this.onAdd.emit(index);
  }

  showAccordeon(index: number) {
    const formArray = this.formGroup.get(this.formName) as FormArray;
    const formGroup = formArray.controls[index] as FormGroup;
    return formGroup.get('showAccordeon').value as boolean;
  }

}
